import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';
import { colors } from 'constants/colors';
import Flex from 'Components/Grid/Flex';
import { PROFILE_NAVBAR_TEST_ID } from '../constants';
import { selectByWL } from 'utils/wLabel';
import { WLabel } from 'constants/enums';
import { FontSize, FontWeight } from 'theme';
import Text from 'Components/Typography/Text';
import { addStyleIfPropTruly } from '../../../utils/styledComponents';
import { IRoute } from '../routes';
import HelpButton from 'Containers/Profile/HelpButton';

export const NAV_ITEM_ADDON_TEST_ID = 'NAV_ITEM_ADDON_TEST_ID';
export const PROFILE_NAVBAR_LINK_NAME_TEST_ID = 'PROFILE_NAVBAR_LINK_NAME_TEST_ID';
export const PROFILE_NAVBAR_LINK_TEST_ID = 'PROFILE_NAVBAR_LINK_TEST_ID';

const Nav = styled(Flex).attrs({
  column: true,
  top: true,
})`
  padding: 30px 0;
`;

export const NavItem = styled(Flex).attrs({ middle: true })`
  letter-spacing: -0.3px;
  margin-top: 20px;

  &:first-child {
    margin-top: 0;
  }
`;

const IconWrapper = styled.div`
  margin-right: 10px;
  height: 16px;
`;

const wlNavItemLinkActiveStyles = selectByWL({
  [WLabel.Default]: `font-weight: ${FontWeight.semiBold};`,
  [WLabel.Globus]: `font-weight: ${FontWeight.extraBold};`,
});

interface INavItemLinkProps {
  blocked?: boolean;
}

const NavLinkStyles = css`
  white-space: nowrap;
  margin-top: 20px;
  display: flex;
  align-items: center;
  color: ${colors.darkGrey};
  text-decoration: none;
  cursor: pointer;
  transition: color 0.048s cubic-bezier(0.4, 0, 0.6, 1) 0.016s;

  &:first-child {
    margin-top: 0;
  }

  &:active,
  &.active {
    ${wlNavItemLinkActiveStyles}
  }

  ${addStyleIfPropTruly(
    'blocked',
    `
    pointer-events: none;
    color: ${colors.warmGrey};
  `
  )}
`;

export const InternalNavLink = styled(NavLink)<INavItemLinkProps>`
  ${NavLinkStyles};
`;

export const HelpButtonLink = styled(HelpButton)`
  ${NavLinkStyles};

  &:hover {
    color: ${colors.darkGrey};
  }
`;

const wlNavItemTextStyles = selectByWL({
  [WLabel.Default]: `letter-spacing: -0.3px;`,
  [WLabel.Globus]: `letter-spacing: 0;`,
});

const NavItemText = styled(Text).attrs({ size: FontSize.s })`
  ${wlNavItemTextStyles}
`;
export interface ISidebarNav {
  routes: IRoute[];
  className?: string;
  withAddons?: boolean;
}

const Navigation: FC<ISidebarNav> = ({ routes, className, withAddons = false }) => {
  return (
    <Nav className={className} data-testid={PROFILE_NAVBAR_TEST_ID}>
      {routes.map(({ icon, path, name, isBlocked, addon }) => (
        <InternalNavLink data-testid={PROFILE_NAVBAR_LINK_TEST_ID} blocked={isBlocked} key={path} to={path}>
          <IconWrapper>{icon}</IconWrapper>
          <NavItemText data-testid={PROFILE_NAVBAR_LINK_NAME_TEST_ID}>{name}</NavItemText>
          {withAddons && addon && <div data-testid={NAV_ITEM_ADDON_TEST_ID}>{addon(isBlocked)}</div>}
        </InternalNavLink>
      ))}
      <HelpButtonLink withIcon />
    </Nav>
  );
};

export default Navigation;
